import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2, BarChart3 } from "lucide-react";
import {
  ResponsiveContainer, LineChart, Line, BarChart, Bar, XAxis, YAxis,
  CartesianGrid, Tooltip, Legend,
} from "recharts";

const OLIVE = "hsl(142 71% 45%)";
const TERRA = "hsl(348 83% 47%)";

export default function ChartsPanel() {
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/charts");
      setData(data);
    })();
  }, []);

  if (data === null)
    return <div className="flex justify-center py-16"><Loader2 className="h-5 w-5 animate-spin text-primary" /></div>;

  const hasData = data.by_category.length > 0;
  if (!hasData)
    return (
      <div className="text-center py-16 border border-dashed border-border rounded-2xl" data-testid="charts-empty">
        <BarChart3 className="h-7 w-7 mx-auto text-muted-foreground mb-3" />
        <p className="text-muted-foreground">Marquez des produits comme sauvés ou jetés pour voir vos tendances.</p>
      </div>
    );

  return (
    <div className="space-y-6" data-testid="charts-panel">
      <div className="bg-card border border-border rounded-2xl p-5 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
        <h3 className="font-display text-xl mb-1">Sauvés vs. gaspillés</h3>
        <p className="text-sm text-muted-foreground mb-5">Tendance sur les 6 derniers mois</p>
        <ResponsiveContainer width="100%" height={260}>
          <LineChart data={data.trend} margin={{ left: -20, right: 8 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="hsl(222 26% 17%)" vertical={false} />
            <XAxis dataKey="month" tick={{ fontSize: 12, fontFamily: "JetBrains Mono" }} stroke="hsl(215.4 16.3% 46.9%)" />
            <YAxis allowDecimals={false} tick={{ fontSize: 12, fontFamily: "JetBrains Mono" }} stroke="hsl(215.4 16.3% 46.9%)" />
            <Tooltip contentStyle={{ borderRadius: 6, border: "1px solid hsl(222 26% 22%)", background: "hsl(222 44% 7%)", color: "hsl(210 40% 96%)", fontFamily: "Plus Jakarta Sans" }} />
            <Legend wrapperStyle={{ fontFamily: "Plus Jakarta Sans", fontSize: 13 }} />
            <Line type="monotone" dataKey="saved" name="Sauvés" stroke={OLIVE} strokeWidth={2.5} dot={{ r: 3 }} />
            <Line type="monotone" dataKey="wasted" name="Jetés" stroke={TERRA} strokeWidth={2.5} dot={{ r: 3 }} />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div className="bg-card border border-border rounded-2xl p-5 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
        <h3 className="font-display text-xl mb-1">Par catégorie</h3>
        <p className="text-sm text-muted-foreground mb-5">Où se joue votre anti-gaspi</p>
        <ResponsiveContainer width="100%" height={280}>
          <BarChart data={data.by_category} layout="vertical" margin={{ left: 30, right: 8 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="hsl(222 26% 17%)" horizontal={false} />
            <XAxis type="number" allowDecimals={false} tick={{ fontSize: 12, fontFamily: "JetBrains Mono" }} stroke="hsl(215.4 16.3% 46.9%)" />
            <YAxis type="category" dataKey="category" width={110} tick={{ fontSize: 11, fontFamily: "Plus Jakarta Sans" }} stroke="hsl(215.4 16.3% 46.9%)" />
            <Tooltip contentStyle={{ borderRadius: 6, border: "1px solid hsl(222 26% 22%)", background: "hsl(222 44% 7%)", color: "hsl(210 40% 96%)", fontFamily: "Plus Jakarta Sans" }} />
            <Legend wrapperStyle={{ fontFamily: "Plus Jakarta Sans", fontSize: 13 }} />
            <Bar dataKey="saved" name="Sauvés" fill={OLIVE} radius={[0, 4, 4, 0]} />
            <Bar dataKey="wasted" name="Jetés" fill={TERRA} radius={[0, 4, 4, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
